import React from "react";
import { Link } from "react-router-dom";

export default function CheckoutCancel() {
  return (
    <div data-testid="checkout-cancel-page" className="max-w-2xl mx-auto px-6 py-32 text-center">
      <div className="overline">Pagamento annullato</div>
      <h1 className="font-serif text-4xl sm:text-5xl mt-4 tracking-tight">Nessun addebito effettuato.</h1>
      <p className="text-sm text-alimi-inkSoft mt-6">
        Hai annullato il checkout. I tuoi articoli sono ancora nel carrello.
      </p>
      <div className="flex justify-center gap-3 mt-10">
        <Link to="/checkout" className="btn-primary">Riprova</Link>
        <Link to="/shop" className="btn-outline">Torna allo shop</Link>
      </div>
    </div>
  );
}
